<template>
 <img v-if="imgUrl" ref="img" @click="previewImage($event)" :src="imgUrl | filterOssLink" alt>
</template>

<script>
export default {
  name: 'ipsosImage',
  props: ['imgUrl', 'preview'],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {

  },
  methods: {
    previewImage () {
      const current = this.$refs.img.src
      if (typeof (WeixinJSBridge) !== 'undefined') {
        /* eslint-disable-next-line */
        WeixinJSBridge.invoke('imagePreview', {
          urls: [current],
          current
        })
      }
    }
  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuImage.vue